import { createSelector } from "reselect"
import { get, first, last, map, chain, size, some } from "lodash"
import { aggregateFactorsSumBy } from "helpers/factorClassification/index"
import { computeFactorCategories } from "helpers/factors"
import { mapPerformanceAttributionFactorReturnsToValues } from "helpers/contributors"

const PERFORMANCE_METRIC_FIELD = "cumulativePercent"

export const getRawPerformanceHistory = state => get(state, "global.data.analyzeCompositePerformance.data.model.simulation.performance")
const getSelectedViews = (_, props) => props.selectedViews
const getSelectedViewsFactors = (_, props) => props.selectedViewsFactors
const getMustAggregateFactors = (_, props) => props.mustAggregateFactors
const getFactorsClassification = (_, props) => props.factorsClassification

const getAdjustedPerformanceHistory = createSelector(
  [getRawPerformanceHistory],
  performanceHistory => mapPerformanceAttributionFactorReturnsToValues(performanceHistory, PERFORMANCE_METRIC_FIELD))

export const getPerformanceHistory = createSelector(
  [getAdjustedPerformanceHistory, getMustAggregateFactors, getSelectedViews, getSelectedViewsFactors, getFactorsClassification],
  (performanceHistory, mustAggregateFactors, selectedViews, selectedViewsFactors, factorsClassification) => map(performanceHistory, daily => {
    let factors = get(daily, "attribution.factors")
    if (mustAggregateFactors) {
      factors = aggregateFactorsSumBy(factorsClassification, factors, "value")
    }

    if (size(selectedViews)) {
      factors = chain(daily)
        .get("factors")
        .filter(factor => some(selectedViewsFactors, item => item.id === factor.id))
        .map(factor => ({ ...factor, customView: true }))
        .concat(factors)
        .value()
    }

    return {
      date: daily.date,
      total: get(daily, ["totalReturn", PERFORMANCE_METRIC_FIELD]),
      factorsTotal: get(daily, ["attribution", "summary", "factors", PERFORMANCE_METRIC_FIELD]),
      alpha: get(daily, ["attribution", "summary", "specific", PERFORMANCE_METRIC_FIELD]),
      trading: get(daily, ["attribution", "summary", "trading", PERFORMANCE_METRIC_FIELD]),
      factors: chain(factors)
        .keyBy("id")
        .mapValues(f => f.value)
        .value(),
      categories: computeFactorCategories(factors, selectedViews),
    }
  }),
)

export const getCurrentPerformance = createSelector(
  [getPerformanceHistory],
  last,
)

export const getFirstPerformanceDate = createSelector(
  [getPerformanceHistory],
  (performanceHistory) => get(first(performanceHistory), "date", null),
)
